import { Pile } from './card/pile';
import { PileId, PileType } from './logic-types';

export class BoardSnapshot {
  public readonly foundations: Pile[];
  public readonly tableaus: Pile[];
  public readonly deck: Pile;
  public readonly waste: Pile;

  constructor(foundations: Pile[], tableaus: Pile[], deck: Pile, waste: Pile) {
    this.foundations = foundations.map((pile) => {
      return Pile.constructFromClone(pile.id, pile.type, pile);
    });

    this.tableaus = tableaus.map((pile) => {
      return Pile.constructFromClone(pile.id, pile.type, pile);
    });

    this.deck = Pile.constructFromClone(PileId.Deck, PileType.Deck, deck);
    this.waste = Pile.constructFromClone(PileId.Waste, PileType.Waste, waste);
  }
}
